<template>
    <div class="flowing-text-container">
        <!-- 元素重复实现无缝循环 -->
        <span v-for="index in 2" :key="index">
            {{ text }}
        </span>
    </div>
</template>

<script lang="ts" setup>
    import { gsap } from 'gsap';
    import { ScrollTrigger } from 'gsap/all';
    import { onMounted } from 'vue';
    gsap.registerPlugin(ScrollTrigger);

    withDefaults(
        defineProps<{
            text: string;
        }>(),
        {
            text: 'Test Test Test Test Test Test Test Test Test Test Test Test Test Test',
        },
    );

    const getCyclicalFlowingTween = (container: HTMLElement) => {
        const textNode = document.querySelectorAll('.flowing-text-container > span');
        const speed = 150; // flowing speed

        // https://greensock.com/forums/topic/28078-reverse-repeat/
        return gsap.to(textNode, {
            xPercent: -100,
            x: -30,
            duration: (2 * textNode[0]?.clientWidth - container?.clientWidth) / speed,
            ease: 'none',
            repeat: -1,
            onReverseComplete: function () {
                this.totalTime(this.duration() * 100 + this.rawTime());
            },
        });
    };
    onMounted(() => {
        const container = document.querySelector('.flowing-text-container') as HTMLElement;
        const tween = getCyclicalFlowingTween(container);
        ScrollTrigger.create({
            trigger: container,
            start: 'top bottom',
            onUpdate: (self) => {
                self.direction === -1 ? tween.reverse() : tween.play();
            },
        });
    });
</script>

<style lang="less" scoped>
    .flowing-text-container {
        width: 100%;
        height: fit-content;
        padding: .convert(30px) [ @vw] 0;
        position: relative;
        color: #ffffff;
        line-height: normal;
        border: 2px solid #ffffff;
        border-radius: 100px;

        overflow: hidden;

        // font
        font-family: Montserrat, 'HarmonyOS Sans SC';
        font-size: 48px;
        font-weight: 500;
        font-style: normal;
        line-height: 60px;
        letter-spacing: 0em;
        text-align: left;
        white-space: nowrap;
        text-transform: capitalize;

        span {
            display: inline-block;
            position: relative;
            margin-right: 30px; // 固定间距
        }

        @media (max-width: @screen-mobile-width) {
            width: 100%;
            height: fit-content;
            padding: .convert(30px) [ @vw] 0;

            color: #fff;
            font-family: Montserrat;
            font-size: 20px;
            line-height: normal;

            // font
            span {
                margin-right: 30px; // 固定间距
            }
        }
    }
</style>
